exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.partner-row-hint[data-v-4f50bd17]{font-size:14px;color:#666;margin-bottom:12px\n}\n.md-raised[data-v-4f50bd17]{color:#fff !important\n}\n.partner-row-disabled[data-v-4f50bd17]{font-size:14px;color:#aaa;font-style:italic\n}\n.partner-row-item[data-v-4f50bd17]{display:flex;align-items:center;gap:8px;margin-bottom:4px\n}\n.partner-row-item .partner-select-container[data-v-4f50bd17]{flex:1\n}\n.partner-row-count[data-v-4f50bd17]{font-size:12px;color:#888;margin-top:8px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4f50bd17","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/distribution/form-components/PartnerRowForm.vue
// module id = 164
// module chunks = 0